
import { Component, Vue, Watch } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import StepsBar from '@/components/StepsBar.vue';
import { ValidationObserver } from 'vee-validate';
import NewClaimDetailForm from '@/components/claims/new-claim/NewClaimDetailForm.vue';
import NewClaimProofUpload from '@/components/claims/new-claim/NewClaimProofUpload.vue';
import NewClaimProductSelect from '@/components/claims/new-claim/NewClaimProductSelect.vue';
import NewClaimOverview from '@/components/claims/new-claim/NewClaimOverview.vue';
import NewClaimFooter from '@/components/claims/new-claim/NewClaimFooter.vue';
import { SalesQuote } from '@/api';

@Component({
  components: {
    StepsBar,
    LayoutDefault,
    ValidationObserver,
    NewClaimDetailForm,
    NewClaimProofUpload,
    NewClaimProductSelect,
    NewClaimOverview,
    NewClaimFooter,
  },
})
export default class NewClaim extends Vue {
  step = 'claim-details';

  steps: string[] = ['claim-details', 'claim-summary'];

  get agreement(): SalesQuote | undefined {
    return this.$store.getters['claim/agreement'];
  }

  async beforeCreate() {
    this.$store.commit('claim/resetCart');
    await this.$store.dispatch('agreement/fetchAgreements');
  }

  @Watch('$route.params', { immediate: true })
  onUrlChange() {
    const { step, agreementId } = this.$route.params;
    this.step = step;
    this.$store.commit('claim/setAgreementId', agreementId);
  }
}
